import React, { useReducer } from 'react'
import HomeContext from './homeContext'
import { apiCall } from '../../../common/api'
import { response } from '../../common'

import { RESPONSE_STATUS, CLEAR_RESPONSE, GET_PRODUCT } from './homeTypes'
import homeReducer from './homeReducer'

const homeState = (props) => {
    const initialState = {
        responseStatus: null,
        all_products: {
            record: {},
            from: '',
        },
    }

    const [state, dispatch] = useReducer(homeReducer, initialState)
    let resp = new response(dispatch, RESPONSE_STATUS)

    const retrieveProduct = async (
        formData,
        fromVariable = 'retrieveProduct'
    ) => {
        try {
            const [res] = await Promise.all([
                apiCall(
                    'post',
                    'retrieveProduct',
                    formData,
                    '',
                    'third_party/homedepot'
                ),
            ])

            if (res.data.status === 'success') {
                console.log(res.data.data.responseData.records, 'reeee')
                dispatch({
                    type: GET_PRODUCT,
                    payload: {
                        record: res.data.data.responseData.records
                            ? res.data.data.responseData.records
                            : {},
                        from: fromVariable,
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, fromVariable)
            } else {
                resp.commonErrorResponse(fromVariable)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const clearResponse = () =>
        dispatch({
            type: CLEAR_RESPONSE,
        })

    return (
        <HomeContext.Provider
            value={{
                responseStatus: state.responseStatus,
                all_products: state.all_products,
                retrieveProduct,
                clearResponse,
            }}
        >
            {props.children}
        </HomeContext.Provider>
    )
}

export default homeState
